import React from "react";
import { motion } from "framer-motion";
import { TEAM } from "@/data/siteContent";

export default function MeetTheTeam() {
  return (
    <section id="team" data-testid="team-section" className="relative py-24 md:py-32 bg-white">
      <div className="container-prose">
        <div className="max-w-2xl">
          <p className="eyebrow mb-5">— Meet The Team</p>
          <h2 className="font-serif text-navy text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Guided by experts who've <span className="italic">lived the journey.</span>
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-10 lg:gap-14">
          {TEAM.map((m, i) => (
            <motion.article
              key={m.name}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`team-card-${m.name.toLowerCase().replace(/\s/g, "-")}`}
              className="group relative bg-[#FAFAF7] border border-navy/10 overflow-hidden rounded-sm hover:border-gold transition-all duration-500 hover:shadow-[0_30px_60px_-30px_rgba(27,42,94,0.3)]"
            >
              <div className="aspect-[4/5] overflow-hidden bg-navy-dark/5 relative">
                <img
                  src={m.image}
                  alt={m.name}
                  style={{ objectPosition: m.objectPosition || "center 30%" }}
                  className="h-full w-full object-cover transform group-hover:scale-105 transition-transform duration-[1200ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/60 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 text-white">
                  <p className="text-gold text-[10px] tracking-[0.3em] uppercase mb-2">
                    {m.role}
                  </p>
                  <h3 className="font-serif text-3xl md:text-4xl tracking-tight">{m.name}</h3>
                </div>
              </div>

              <div className="p-6 md:p-8">
                <ul className="space-y-2 mb-5">
                  {m.credentials.map((c) => (
                    <li key={c} className="flex items-start gap-3 text-sm md:text-[15px] text-navy-deeper/85">
                      <span className="mt-2 w-1.5 h-1.5 bg-gold rounded-full flex-shrink-0" />
                      <span>{c}</span>
                    </li>
                  ))}
                </ul>
                <p className="text-navy-deeper/70 text-sm md:text-base leading-relaxed italic font-serif">
                  {m.bio}
                </p>
              </div>
              <div className="h-1 bg-gold scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
